// @givmo/board — the notes beside a director whose recorded term had ended (CBG-YR3-VOTENOTE; backend
// `board_minutes.md` §V8): the vote dialog, the circulate preview and the consent page say the same
// recorded fact in one place. "Who was there" says the holdover line instead, from its own one
// definition (`officerRolesL3Words.termEndedStillServing`).
//
// ══ WHICH WORDS ARE APPROVED ════════════════════════════════════════════════════════════════════
//
// - `termYouRecordedEnded` is SHIPPED: the consent page's "Who has to sign" has said it since CBG-SPA2
//   (2026-07-31). It moved here, unchanged, so the vote dialog and the circulate preview reuse it
//   exactly (the derivation §2.4: "the consent page's shipped sentence").
// - `tallyTermEnded` is APPROVED: copy round CBG-YR3-COPY1's second part, cut votenote's page
//   (`scratchpad/2026-10-14-votenote-copy-round/copy-review.html`), approved as drafted (Jonathan,
//   2026-10-15 06:01 PDT, "go with your recs"). Not drawn: frame `t6` draws the dialog seat by
//   seat.
//
// ⚠ Plan §3.2 and §3.4 bind every line: a date the board recorded, never that a term "expired", that
// the person may not vote, or that anything is required. Nothing here disables or refuses anything; a
// held-over director's vote is recorded like any other (the derivation's I2).

export const termNoteWords = {
  /**
   * Shipped (the consent page, since CBG-SPA2). Under a held-over director's choice in the vote
   * dialog (frame `t6`), beside them in the circulate preview (not drawn) and on the consent page.
   */
  termYouRecordedEnded: (date: string): string =>
    `The term you recorded for this seat ended ${date}.`,
  /**
   * Approved (CBG-YR3-COPY1). Not drawn: the vote dialog in tally mode, where no field names a
   * person, one line per held-over director above the three numbers.
   */
  tallyTermEnded: (name: string, date: string): string =>
    `${name}’s term, as you recorded it, ended ${date}.`,
} as const;
